import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../media/logo.svg';
import MenuItem from './menu-item/menu-item';
import './sidebar.css';

class Sidebar extends Component {
  render() {
    return (
      <div className="sidebar-container">
        <div className="sidebar-pad"></div>
        <div className="sidebar">
          <Link to="/"><img src={logo} className="logo p-5" alt="logo" /></Link>
          <MenuItem to="/" name="Home" icon="fab fa-fort-awesome" />
          <MenuItem to="/portfolio" name="Portfolio" icon="fas fa-anchor" />
          <MenuItem to="/news" name="News" icon="far fa-newspaper" />
          <MenuItem to="/contact" name="Contact" icon="far fa-envelope" />

          <div className="sidebar-footer">
            Copyright {(new Date().getFullYear())} <br />
            <Link to="/">Surfside Solutions</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar.js